export default {"src":"/_next/static/media/feature-image-01.3f8024ce.svg","height":2210,"width":2210,"blurWidth":0,"blurHeight":0};